import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { INDIA, STATES } from "../data/india";

export const cityPath = (state, city) => `/city/${encodeURIComponent(state)}/${encodeURIComponent(city)}`;

export default function Cities() {
  const [q, setQ] = useState("");
  useEffect(() => { document.title = "Cars by City | CarSaleMarket.com"; }, []);
  const s = q.trim().toLowerCase();
  const rows = STATES.map((st) => [st, [...INDIA[st]].sort().filter((c) => !s || c.toLowerCase().includes(s) || st.toLowerCase().includes(s))]).filter(([, c]) => c.length);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32" data-testid="cities-page">
      <p className="eyebrow mb-3">Pan-India</p>
      <h1 className="font-display text-5xl sm:text-6xl mb-4">Find cars in your city</h1>
      <p className="text-gray-400 mb-8">Every state and union territory, with a showcase page for each city.</p>
      <input className="lux-input max-w-md mb-12" placeholder="Search city or state..." value={q} onChange={(e) => setQ(e.target.value)} data-testid="cities-search" />
      <div className="columns-1 md:columns-2 lg:columns-3 gap-8 space-y-8">
        {rows.map(([st, cities]) => (
          <div key={st} className="lux-card p-6 break-inside-avoid" data-testid={`state-block-${st}`}>
            <p className="font-display text-2xl gold-text mb-4">{st}</p>
            <div className="flex flex-wrap gap-x-4 gap-y-2 text-sm">
              {cities.map((c) => <Link key={c} to={cityPath(st, c)} className="text-gray-300 hover:text-[#F5E08F] transition-colors">{c}</Link>)}
            </div>
          </div>
        ))}
      </div>
      {!rows.length && <p className="text-gray-400">No matching city.</p>}
    </div>
  );
}
